import { render, staticRenderFns } from "./ClientAddressCarousel.vue?vue&type=template&id=43d8d80e&scoped=true"
import script from "./ClientAddressCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddressCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClientAddressCarousel.vue?vue&type=style&index=0&id=43d8d80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d8d80e",
  null
  
)

export default component.exports